import { NgModule } from "@angular/core";
import { VenueSportFormatSurfaceTextPipe } from "./venue-sport-format-surface-text.pipe";

@NgModule({
    exports: [
        VenueSportFormatSurfaceTextPipe
    ],
    declarations: [
        VenueSportFormatSurfaceTextPipe
    ],
})
export class SplitPaymentsPipeModule {}
